/**
 * Centralized Currencies Configuration
 * Contains all available currencies with their symbols and codes
 * Used throughout the application for dropdown selections and displays
 */

export const CURRENCIES = [
 
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' }
 
];

/**
 * Get currency object by code
 * @param {string} code - Currency code (e.g., 'INR')
 * @returns {object|null} Currency object or null if not found
 */
export const getCurrencyByCode = (code) => {
  return CURRENCIES.find(curr => curr.code === code) || null;
};

/**
 * Get currency symbol by code
 * @param {string} code - Currency code (e.g., 'INR')
 * @returns {string} Currency symbol
 */
export const getCurrencySymbol = (code) => {
  const currency = getCurrencyByCode(code);
  return currency ? currency.symbol : code;
};

/**
 * Format price with currency
 * @param {number} price - Price amount
 * @param {string} currencyCode - Currency code
 * @param {boolean} showCode - Show currency code instead of symbol
 * @returns {string} Formatted price string
 */
export const formatPriceWithCurrency = (price, currencyCode, showCode = false) => {
  const currency = getCurrencyByCode(currencyCode);
  if (!currency) return `${price} ${currencyCode}`;
  
  const display = showCode ? currency.code : currency.symbol;
  return `${display}${price}`;
};

/**
 * Format currency dropdown option display
 * @param {object} currency - Currency object
 * @returns {string} Formatted display string
 */
export const formatCurrencyDisplay = (currency) => {
  return `${currency.symbol} - ${currency.code} (${currency.name})`;
};

/**
 * Get all currency codes
 * @returns {array} Array of currency codes
 */
export const getCurrencyCodes = () => {
  return CURRENCIES.map(curr => curr.code);
};

/**
 * Default currency (can be changed based on app configuration)
 */
export const DEFAULT_CURRENCY = 'INR';
